import { form } from "./form";

/** @type {import("vuex").Module} */
export const employment = {
    namespaced: true,
    modules: { form },
};

export default employment;
